var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRoundedRectangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 16,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 16,
  fill: "#5C5F62",
  rx: 4
})));
export default SvgRoundedRectangle;